module.exports = "/static/assets/51d228f5f5d5e42a252cc88210fd0cd2.svg";